import { useMemo } from 'react';
import { SECTIONS } from '@/components/wizard/constants';
import {
    getCustomSectionById,
    getSectionContent,
    getSectionTitle,
    resolveReportSectionOrder,
} from '@/lib/report-sections';
import { ReportData, Section } from '../components/preview/types';
import { SectionDisplay } from '../components/wizard/types';

const DEFAULT_SECTION_TITLES: Record<string, string> = {
    [SECTIONS.DEMAND_DESCRIPTION]: 'Descrição da Demanda',
    [SECTIONS.PROCEDURES]: 'Procedimentos',
    [SECTIONS.BEHAVIOR_OBSERVATIONS]: 'Observação do Comportamento',
    [SECTIONS.CLINICAL_HISTORY]: 'História Clínica',
    [SECTIONS.TESTS]: 'Análise',
    [SECTIONS.DIAGNOSIS]: 'Conclusão',
    [SECTIONS.RECOMMENDATIONS]: 'Recomendações',
};

export function useReportSections(data: ReportData) {
    return useMemo(() => {
        const allSections: SectionDisplay[] = resolveReportSectionOrder(data).map(
            (sectionId, index) => {
                const customSection = getCustomSectionById(data, sectionId);
                const fallbackTitle = customSection
                    ? 'Nova seção'
                    : DEFAULT_SECTION_TITLES[sectionId] || 'Seção';

                return {
                    id: sectionId,
                    content: customSection
                        ? customSection.content
                        : sectionId === SECTIONS.TESTS
                          ? data.tests?.blocks
                          : getSectionContent(data, sectionId),
                    title: getSectionTitle(data, sectionId, fallbackTitle),
                    number: index + 1,
                    isCustom: Boolean(customSection),
                };
            },
        );

        return allSections as Section[];
    }, [data]);
}
